import {
  CreditsPointFilter,
  DashboardReportFilter,
  DriversFilter,
  UsersFilter,
  VehiclesFilter
} from "@/components/@filter";
import {ReportFilter} from "@/components/@filter/report-filter";
import {NeoTextBox} from "@/components/forms";
import {Distance} from "@/components/pages/reports/report-topbar/distance";
import {FuelConsumptionHeader} from "@/components/pages/reports/report-topbar/fuelConsumtion";
import NokiaSuddenAcceleration from "@/components/pages/reports/report-topbar/nokiaSuddenAcceleration";
import NokiaTimeDriven from "@/components/pages/reports/report-topbar/nokiaTimeDriven";
import {RFIDuserswipes} from "@/components/pages/reports/report-topbar/rfidUserswipe";
import {Speed} from "@/components/pages/reports/report-topbar/speed";
import {UhfCanteenHeader} from "@/components/pages/reports/report-topbar/uhfCanteen";
import {HardwareTopBar} from "@/components/pages/reports/report-topbar/uhfHardware";
import {WrongSwipeHeaderTopBar} from "@/components/pages/reports/report-topbar/wrongSwipe";
import {RoutesPlanSummary} from "@/components/pages/routes/activeRoute/route-summary-cards";
import {BlockTraking} from "@/components/pages/vehicles/blkVehicleTracking";
import {UserVehicleSwitcher} from "@/components/pages/vehicles/userVehicleSwitcher";
import {
  ColumnIcon,
  DownloadIcon,
  NeoSubHeader,
  PlusIcon,
  SearchIcon
} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {Button, Tab, Tabs, Tooltip} from "@nextui-org/react";
import {useRouter} from "next/navigation";
import {useCallback, useEffect, useMemo, useState} from "react";
export const NeoAGHeader: React.FC<NeoTableHeaderProps> = ({
  meta,
  filterValue,
  onClear,
  onSearchChange,
  statusFilter,
  setStatusFilter,
  statusOptions,
  count,
  onRowsPerPageChange,
  onApplyFilters,
  url,
  activeFilters,
  reportRequest,
  reportFilters,
  dashboardfilter,
  onChangeTab,
  tabView,
  innerFilters,
  headerSidebar,
  onExportClick,
  fullResponseData,
  setActivePanel,
  activePanel,
  openFormModal,
  checkedRows,
  rowSelection,
  otherDatas,
  expensefilter,
  expensesummaryfilter
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const {vehicles, offset, filterContext, uhfHardwareGroups} = useNeoContext();
  const [selectedTabKey, setSelectedTabKey] = useState<string | number>(1);

  useEffect(() => {
    if (meta.id === 4 && vehicles.length > 0) {
      //report
      const currentDate = new Date();
      const fromDate = new Date(currentDate);
      const toDate = new Date(currentDate);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: fromDate.getTime(),
        to: toDate.getTime()
      };
      let trackerIds;
      if (activeFilters.includes("vehicle")) {
        trackerIds = vehicles.map(v => v.trackerId); // multiple
      } else {
        trackerIds = [vehicles[0]?.trackerId]; // single wrapped in array
      }
      reportRequest({trackerId: trackerIds, ...selectedDateRange});
    }
  }, [vehicles]);
  /* Dashboard Report Filters */
  useEffect(() => {
    const instituteuserids = dashboardfilter?.instituteuserids
      ? dashboardfilter?.instituteuserids
      : [];
    if (meta.id === 5) {
      const status = dashboardfilter?.status ? dashboardfilter?.status : [];
      if (tabView && tabView.length > 0) {
        const defaultTabKey = String(status?.[0] ?? tabView[0]?.id);
        setSelectedTabKey(defaultTabKey);
      }

      const filters = {
        branch: instituteuserids,
        trackers: [],
        status: status
        //type: []
        // userType: []
      };

      if (innerFilters) {
        innerFilters.forEach((filter: any) => {
          const key = filter.uid as keyof typeof filters;
          // if (key in filters) {
          filters[key] = filter.defaultValue;
          //}
        });
      }
      const currentDate = new Date();
      const fromDate = new Date(currentDate);
      const toDate = new Date(currentDate);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      const selectedDateRange = {
        from: fromDate.getTime(),
        to: toDate.getTime(),
        filters: filters,
        offset: offset
        // threshold: "",
        // status: [1, 2, 3, 4]
      };
      // if (activeFilters.includes("threshold")) {
      //   selectedDateRange.threshold = "70";
      // }
      // if (activeFilters.includes("status")) {
      //   selectedDateRange.status = [1, 2, 3, 4];
      // }

      reportRequest({...selectedDateRange});
    }
  }, []);
  /* Dashboard Report Filters */
  useEffect(() => {
    let instituteuserids: any = [];
    if (meta.id === 5) {
      instituteuserids = dashboardfilter?.instituteuserids
        ? dashboardfilter?.instituteuserids
        : [];
    } else {
      instituteuserids = filterContext.client.institutionUserId
        ? [filterContext.client.institutionUserId]
        : [];
    }
    let uhfHardwareGroupIds: any = [];
    if (uhfHardwareGroups && uhfHardwareGroups.length > 0) {
      uhfHardwareGroupIds = uhfHardwareGroups.map((group: any) =>
        group.id.toString()
      );
    }

    // if (meta.id === 5) {
    const status = dashboardfilter?.status ? dashboardfilter?.status : [];
    const filters = {
      branch: instituteuserids,
      trackers: [],
      status: status,
      source: "0",
      userType: "1", // Default to Student
      groupId: uhfHardwareGroupIds
    };

    if (innerFilters) {
      innerFilters.forEach((filter: any) => {
        const key = filter.uid as keyof typeof filters;
        // console.log(key);
        // if (key in filters) {
        filters[key] = filter.defaultValue;
        //}
      });
    }
    const currentDate = new Date();
    const fromDate = new Date(currentDate);
    const toDate = new Date(currentDate);
    let filterType = "1";
    //console.log(meta.title);
    if (
      meta.title === "Performance Reports ( Distance ) " ||
      meta.title === "Log Reports ( Speed Breach ) " ||
      meta.title === "Transaction History"
    ) {
      toDate.setHours(23, 59, 59, 999);
      fromDate.setDate(toDate.getDate() - 6); // Last 7 days = today + previous 6
      fromDate.setHours(0, 0, 0, 0);
      filterType = "7";
    } else {
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
    }

    const selectedDateRange = {
      from: fromDate.getTime(),
      to: toDate.getTime(),
      filters: filters,
      offset: offset,
      filterType: filterType,
      staffClassId: [] //this filter used for gate attendance report its also not required value
      // threshold: "",
      // status: [1, 2, 3, 4]
    };
    // if (activeFilters.includes("threshold")) {
    //   selectedDateRange.threshold = "70";
    // }
    // if (activeFilters.includes("status")) {
    //   selectedDateRange.status = [1, 2, 3, 4];
    // }
    //console.log(selectedDateRange);
    reportRequest({...selectedDateRange});
    // }
  }, []);

  // arranging key and value seperation
  const transformFilters = (
    filters: Record<string, string | number>
  ): Filter | {} => {
    const filledEntries = Object.entries(filters).filter(
      ([, value]) => value !== ""
    );

    if (filledEntries.length > 0) {
      const filterColumn = filledEntries.map(([key]) => key);
      const filterValues = filledEntries.map(([, value]) => value);
      return {filterColumn, filterValues};
    }

    return {};
  };
  const handleFilterSubmit = (data: any) => {
    //const transformedFilters = transformFilters(data);
    // console.log(data);
    // onApplyFilters(transformedFilters);
    if (meta.id === 5) {
      const instituteuserids = dashboardfilter?.instituteuserids
        ? dashboardfilter?.instituteuserids
        : [];
      //if(data.filters.)
      // const status = dashboardfilter?.status ? dashboardfilter?.status : [];
      const filters = {...data.filters, branch: instituteuserids};
      const selectedDateRange = {
        filters: filters,
        offset: offset
      };
      reportRequest({...data, ...selectedDateRange});
    } else {
      const filters = {...data.filters};
      const selectedDateRange = {
        filters: filters,
        offset: offset
      };
      reportRequest({...data, ...selectedDateRange});
    }
    setIsPopupOpen(false);
  };
  const {push} = useRouter();
  // const renderFilterComponent = (id: any) => {
  //   console.log("renderFilterComponent");
  //   switch (id) {
  //     case 1:
  //       return <UsersFilter onSubmit={handleFilterSubmit} />;
  //     case 2:
  //       return <VehiclesFilter onSubmit={handleFilterSubmit} />;
  //     case 3:
  //       return <DriversFilter onSubmit={handleFilterSubmit} />;
  //     case 4:
  //       return (
  //         <ReportFilter
  //           onSubmit={handleFilterSubmit}
  //           activeFilters={activeFilters}
  //           oldFilter={reportFilters}
  //         />
  //       );
  //     case 5:
  //       return (
  //         <DashboardReportFilter
  //           onSubmit={handleFilterSubmit}
  //           activeFilters={activeFilters}
  //           oldFilter={reportFilters}
  //           innerFilters={innerFilters}
  //         />
  //       );
  //     default:
  //       return null;
  //   }
  // };
  const renderFilterComponent = useCallback(
    (id: any) => {
      //console.log("renderFilterComponent");
      switch (id) {
        case 1:
          return <UsersFilter onSubmit={handleFilterSubmit} />;
        case 2:
          return <VehiclesFilter onSubmit={handleFilterSubmit} />;
        case 3:
          return <DriversFilter onSubmit={handleFilterSubmit} />;
        case 4:
          return (
            <ReportFilter
              onSubmit={handleFilterSubmit}
              activeFilters={activeFilters}
              oldFilter={reportFilters}
              innerFilters={innerFilters}
            />
          );
        case 5:
          return (
            <DashboardReportFilter
              onSubmit={handleFilterSubmit}
              activeFilters={activeFilters}
              oldFilter={reportFilters}
              innerFilters={innerFilters}
            />
          );
        case 7:
          return (
            <CreditsPointFilter
              onSubmit={handleFilterSubmit}
              activeFilters={activeFilters}
              oldFilter={reportFilters}
              innerFilters={innerFilters}
            />
          );
        default:
          return null;
      }
    },
    [reportFilters, activeFilters, innerFilters]
  );

  const renderHeaderCard = useMemo(() => {
    //console.log("renderHeaderCard11");
    return headerSidebar?.map((topbar: any, index: number) => {
      switch (topbar.menu) {
        //distanceHeader
        case "distanceHeader":
          if (!headerSidebar || !fullResponseData?.statistics) return null;
          return (
            <Distance key={index} statistics={fullResponseData.statistics} />
          );
        case "speedHeader":
          if (!headerSidebar || !fullResponseData?.statistics) return null;
          return <Speed key={index} statistics={fullResponseData.statistics} />;
        case "rfidUserswipeTopbar":
          return <RFIDuserswipes data={fullResponseData} />;
        case "uhfCanteenHeader":
          return <UhfCanteenHeader headerData={fullResponseData?.headerData} />;
        case "hardwareReportBioMetr":
          return <HardwareTopBar data={fullResponseData} />;
        //Route Plan -> Active Routes
        case "activeRouteListHeader":
          if (
            !headerSidebar ||
            !fullResponseData?.statistics ||
            fullResponseData.rows.length === 0
          )
            return null;
          return <RoutesPlanSummary stats={fullResponseData.statistics} />;
        case "wrongSwipesHeader":
          return <WrongSwipeHeaderTopBar data={fullResponseData} />;
        case "fuelConsumption":
          return <FuelConsumptionHeader />;
        case "nokiaTimeDriven":
          return <NokiaTimeDriven />;
        case "nokiaSuddenAcceleration":
          return <NokiaSuddenAcceleration />;
        default:
          return null;
      }
    });
  }, [headerSidebar, fullResponseData]);

  // const renderHeaderCard = () => {
  //   console.log("renderHeaderCard");
  //   return headerSidebar?.map((topbar: any, index: number) => {
  //     switch (topbar.menu) {
  //       case "distanceHeader":
  //         return <Distance key={index} />;
  //       default:
  //         return null;
  //     }
  //   });
  // };
  const handleClick = () => {
    if (url?.page?.add === "drivers/new/create/driver") {
      openFormModal("addeditDriver", true);
    } else {
      if (meta?.id === 6) {
        if (url?.page?.add === "fueladd") {
          openFormModal("fuelform", true);
        } else if (url?.page?.add === "maintenanceadd") {
          openFormModal("maintenanceform", true);
        } else if (url?.page?.add === "miscellaneousadd") {
          openFormModal("miscellaneousform", true);
        } else if (url?.page?.add === "expensesadd") {
          openFormModal("expensesadd", true);
        }
      } else {
        push(url?.page?.add);
      }
    }
  };

  const onShowColumnsClick = () => {
    if (!activePanel) {
      setActivePanel("columns");
    } else {
      setActivePanel(null);
    }
  };
  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="flex gap-2">
          {meta?.hasFilter && (
            <div className="relative">
              <img
                className="center h-5 w-5 pt-2 "
                src="/icons/filter.svg"
                onClick={() => setIsPopupOpen(prev => !prev)}
              />
              {isPopupOpen && (
                <div className="absolute left-0 z-50 mt-2 w-auto">
                  <div className="rounded-md border bg-white p-5 shadow-lg">
                    <Button
                      isIconOnly
                      size="sm"
                      variant="light"
                      onClick={() => setIsPopupOpen(false)}
                      className="absolute right-2 top-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </Button>
                    {renderFilterComponent(meta.id)}
                  </div>
                </div>
              )}
            </div>
          )}
          <NeoSubHeader message={meta.title}></NeoSubHeader>
        </div>
        <div className="flex items-center justify-between">
          {tabView && (
            <div className="flex flex-col items-start">
              <div className="flex w-full justify-start">
                <Tabs
                  key="underlined"
                  aria-label="Tabs variants"
                  selectedKey={selectedTabKey}
                  // variant="underlined"
                  // onSelectionChange={onChangeTab}
                  onSelectionChange={key => {
                    setSelectedTabKey(key);
                    onChangeTab(key);
                  }}
                  color="primary"
                  radius="full"
                  size="sm"
                >
                  {tabView.map((item: any, index: number) => (
                    <Tab key={item.id} title={item.label}></Tab>
                  ))}
                </Tabs>
              </div>
            </div>
          )}
        </div>
      </div>
      {headerSidebar && renderHeaderCard}

      {/* {meta?.description && count && (
        <div className="flex items-center justify-between">
          <span className="text-small text-default-400">
            {meta.description} : {count}
          </span>
          <label className="flex items-center text-small text-default-400">
            Rows per page:
            <select
              className="bg-transparent text-small text-default-400 outline-none"
              onChange={onRowsPerPageChange}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15" selected>
                15
              </option>
              <option value="25">25</option>
              <option value="100">100</option>
            </select>
          </label>
        </div>
      )} */}
      <div className="flex items-center justify-between ">
        <span className="text-small text-default-400">
          {meta.description} : {count}
        </span>
        <div className="flex items-center justify-between">
          <NeoTextBox
            isClearable
            className="w-full px-5 sm:max-w-[44%] md:max-w-[75%] lg:max-w-[75%] xl:w-[100%]"
            placeholder="Search..."
            startContent={<SearchIcon />}
            value={filterValue}
            onClear={() => onClear()}
            size="sm"
            onValueChange={onSearchChange}
          />
          {/* <div className="mt-2 px-2">
              <UploadIcon />
            </div> */}
          {rowSelection && (
            <>
              <div className="w-full">
                <BlockTraking otherDatas={otherDatas} />
              </div>
              <div className="w-full">
                <UserVehicleSwitcher checkedRows={checkedRows} />
              </div>
            </>
          )}
          {meta?.hasCreate && (
            <div className="cursor-pointer px-2" onClick={handleClick}>
              <PlusIcon />
            </div>
          )}
          {meta?.hasDownload && (
            <div className="cursor-pointer px-2" onClick={onExportClick}>
              <DownloadIcon />
            </div>
          )}
          <Tooltip
            showArrow={true}
            color={"primary"}
            placement="top-end"
            content="Toggle visibility of table columns to customize your view."
          >
            <div
              className="cursor-pointer px-2"
              onClick={onShowColumnsClick}
              // title="Toggle visibility of table columns to customize your view."
            >
              <ColumnIcon />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export function capitalize(str: any) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
